import { useQuery } from '@tanstack/react-query';

import { GetCustomersParams } from '../../../../common/api/clients/company.api';
import { queries } from '../../../../common/api/queryKeys/queries';

export const useCustomerList = (params: GetCustomersParams) => {
    return useQuery(queries.customers.list(params));
};
